import React, { Suspense, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import NewLogo from "../../components/CNLogo/NewLogo";
import RevealOnScroll from "../../components/RevealOnScroll";
import Lcp from "./Lcp";
import MoreThanSkills from "./MoreThanSkills";
import LoginForm from "./LoginForm";
import StatsSection from "./StatsSection";
import { OurLearners } from "./OurLearners";
import { WhyLearnTube } from "./WhyLearntube";
import SuccessStory from "../CertificateVerification/SuccessStory";
import SucessfulLearners from "./SucessfulLearners";
import { ReadyToJoin } from "./ReadyToJoin";
import Footer25 from "./Footer25";
import LazySpinner from "../../components/LazySpinner";
import OurLeanersModal from "./OurLeanersModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getXanoAuthLinkedInToken,
  getXanoAuthToken,
  setOnboardingPhase,
} from "../../redux/actions/authentication";
import { fetchIsUserFromBetaProduct } from "../../redux/actions/personaliseCourse";
import { setActivationPhase } from "../../redux/actions/contentPayer";
import { SET_IS_ACTIVATION } from "../../redux/actions/types";
import { toast } from "react-toastify";
import PlacementSuccessStory from "../../components/PlacementSuccessStory";
import { AwardsSectionDesktop } from "./AwardsSectionDesktop";
import LoginLoader from "./LoginLoader";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";
import LoginModal from "../../components/Navbar/NavBarRight/LoginModal";
import StickyBar from "./StickyBar";
import useInView from "../../hooks/useInView";

const redirectUri = "https://learntube.ai";
const LandingPage25 = () => {
  const navigate = useNavigate();
  const showRecognisedSection = useSelector(
    (store) => store?.userActivity?.showRecognisedSection
  );
  const [searchParams, setSearchParams] = useSearchParams();
  let code = searchParams?.get("code");
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLinkedInLoading, setIsLinkedInLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginModal , setLoginModal] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);
  const [isStickyBarVisible, setIsStickyBarVisible] = useState(false);
  const formSwiperRef = useRef(null);
  const formScrollRef = useRef(null);
  const token = useSelector((store) => store?.authentication?.user_token);
  const viewRef = useRef(null);

  const navigateToHome = () => {
    navigate("/");
  };

  useEffect(() => {
    if (!token) Mixpanel.track(Constants.Mixpanel.LANDING_PAGE_VISIT);
    if (token) {
    navigate("/courses");
    }
}, []);


  useEffect(() => {
    function removeQueryParam(param) {
      const url = new URL(window.location.href);

      url.searchParams.delete(param);

      const newUrl =
        url.pathname +
        (url.search ? "?" + url.searchParams.toString() : "") +
        url.hash;
      try {
        window.history.replaceState({}, document.title, newUrl + "#_");
        window.history.replaceState({}, document.title, newUrl);
      } catch (e) {
        window.location.replace(newUrl);
      }
    }

    if (code) {
      console.log("code", code);
      handleLinkedInLogin(code, setIsLinkedInLoading);
      removeQueryParam("code");
    }
  }, [dispatch]);

  function handleLinkedInLogin(code, setIsLinkedInLoading) {
    setIsLinkedInLoading(true);
    setIsLoading(true);
    Mixpanel.track(Constants.Mixpanel.LANDING_PAGE_LOGIN_WITH_LINKEDIN_CLICKED);
    dispatch(
      getXanoAuthLinkedInToken(
        code,
        redirectUri,
        (successObj) => {
          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
              distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
              $first_name: successObj?.first_name,
              $last_name: successObj?.last_name,
              $email: successObj?.email,
              $name: successObj?.name,
          });
          if (successObj?.result !== "failed") {
            dispatch(
              fetchIsUserFromBetaProduct(
                (res) => {
                  console.log("monday", res);
                  if (
                    res?.data?.is_ninjacurate_user ||
                    res?.data?.ninjacurate_is_paid
                  ) {
                    dispatch(
                      setOnboardingPhase(
                        (res1) => {},
                        (err1) => {}
                      )
                    );
                    dispatch(
                      setActivationPhase((successObj) =>
                        dispatch({ type: SET_IS_ACTIVATION, payload: false })
                      )
                    );
                  }
                },
                (err) => {}
              )
            );
          }
          if (successObj?.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : "/courses",
              { replace: true }
            );
            setIsLinkedInLoading(false);
            setIsLoading(false);
          } else {
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
              setIsLinkedInLoading(false);
              code = null;
              setIsLoading(false);
            } else {
              navigate("/verification");
              code = null;
              setIsLoading(false);
            }
            setIsLoading(false);
            setIsLinkedInLoading(false);
          }
        },
        (errorObj) => {
          setIsLinkedInLoading(false);
          setIsLoading(false);
          code = null;
          toast.error(errorObj?.message);
        }
      )
    );
  }

  async function authResponse(response, setIsGoogleLoading) {
    setIsGoogleLoading(true);
    setIsLoading(true);
    Mixpanel.track(Constants.Mixpanel.LANDING_PAGE_LOGIN_WITH_GOOGLE_CLICKED);
    if (response.error || (response.status && response.status === "unknown")) {
      setIsGoogleLoading(false);
      setIsLoading(false);
      console.log("Auth Failed: ", response.error);
    } else {
      const tokenID = response?.tokenObj?.access_token;

      await dispatch(
        getXanoAuthToken(tokenID, (successObj) => {
          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
              distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
              $first_name: successObj?.first_name,
              $last_name: successObj?.last_name,
              $email: successObj?.email,
              $name: successObj?.name,
          });

          if (successObj?.result !== "failed") {
            dispatch(
              fetchIsUserFromBetaProduct(
                (res) => {
                  console.log("monday", res);
                  if (
                    res?.data?.is_ninjacurate_user ||
                    res?.data?.ninjacurate_is_paid
                  ) {
                    dispatch(
                      setOnboardingPhase(
                        (res1) => {},
                        (err1) => {}
                      )
                    );
                    dispatch(
                      setActivationPhase((successObj) =>
                        dispatch({ type: SET_IS_ACTIVATION, payload: false })
                      )
                    );
                  }
                },
                (err) => {}
              )
            );
          }

        
          if (successObj?.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : "/courses",
              { replace: true }
            );
            setIsGoogleLoading(false);
            setIsLoading(false);
          } else {
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
              setIsGoogleLoading(false);
              setIsLoading(false);
            } else {
              navigate("/verification");
              setIsLoading(false);
            }
          }
        })
      );
    }
  }

  const navigateLinkedInLogin = () => {
    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?client_id=86h7ayn66hgjuf&redirect_uri=${redirectUri}&response_type=code&scope=w_member_social%20profile%20openid%20email%20r_basicprofile`;
  };

  const dummyRefDesktop = useRef(null);
  const dummyRefMobile = useRef(null);

  const formSwiperRefDesktop = useRef(null);
  const formSwiperRefMobile = useRef(null);

  const loginEmailRefMobile = useRef(null);
  const loginEmailRefDesktop = useRef(null);

  const handleScroll = (ref) => {
    console.log("ref", ref.current);
    if(ref.current){
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handleFormSlide = (ref , index) => {
    if(ref?.current){
      ref?.current?.swiper?.slideTo(1 - index);
    }
  }

  console.log("isStickyBarVisible", isStickyBarVisible);
  return (
    <div className="w-full">
    <div
      className={`relative w-full px-4 pt-4 md:px-0 md:pt-6 no-scrollbar ${isLoading ? "h-screen overflow-hidden" : "min-h-screen"}`}
      style={{
        background:
          "radial-gradient(ellipse at center, #00385C 0%, #001C2C 100%)",
      }}
    >
      {isLoading && <LoginLoader />}
      <div className="w-full md:hidden overflow-y-auto">
        <NewLogo navigateToHome={navigateToHome} setLoginModal={setLoginModal} formScrollRef={formScrollRef} formSwiperRef={formSwiperRefMobile} handleScroll={handleScroll} dummyRef={dummyRefMobile} handleFormSlide={handleFormSlide} loginEmailRef={loginEmailRefMobile}/>
      {/* <h2 className="text-white" onClick={handleScroll}>Click me</h2> */}
        <Lcp
          authResponse={authResponse}
          navigateLinkedInLogin={navigateLinkedInLogin}
          onStickyBarVisibilityChange={setIsStickyBarVisible}
          viewRef={viewRef}
        />
       
          <OurLearners />
      
      
          <div className="mt-11 w-full">
            <LoginForm
              authResponse={authResponse}
              isLinkedInLoading={isLinkedInLoading}
              navigateLinkedInLogin={navigateLinkedInLogin}
              formSwiperRef={formSwiperRefMobile}
              handleFormSlide={handleFormSlide}
              formScrollRef={formScrollRef}
              dummyRef={dummyRefMobile}
              loginEmailRef={loginEmailRefMobile}
            />
          </div>

   
         <RevealOnScroll animation="slide-up">
          <WhyLearnTube />
        </RevealOnScroll>
        <RevealOnScroll>
          <MoreThanSkills />
        </RevealOnScroll>
       

        <RevealOnScroll>
          <div className="mt-11 w-full">
            <StatsSection />
          </div>
        </RevealOnScroll>


        <RevealOnScroll>
          <div className="mt-11">
            <SuccessStory />
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="mt-11 flex flex-col items-center justify-center">
            <p className="whitespace-nowrap text-base font-normal leading-[normal] tracking-[0] text-[#ffffff80] [font-family:'Inter',Helvetica]">
            Success Stories Of Our
            </p>

            <h2
              className="mb-6 text-center text-2xl font-semibold leading-[normal] tracking-[0] text-white [font-family:'Inter',Helvetica]"
              style={{
                background:
                  "linear-gradient(to right, #FFFFFF 0%, #F7E394 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Amazing Learners
            </h2>
            <PlacementSuccessStory />
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <ReadyToJoin authResponse={authResponse} />
        </RevealOnScroll>
      </div>
      <div className="mx-auto no-scrollbar flex hidden h-full w-full max-w-[1200px] flex-col items-center justify-start md:block">
        <NewLogo navigateToHome={navigateToHome} setLoginModal={setLoginModal} handleScroll={handleScroll} dummyRef={dummyRefDesktop} formScrollRef={formScrollRef} formSwiperRef={formSwiperRefDesktop} handleFormSlide={handleFormSlide} loginEmailRef={loginEmailRefDesktop}/>

        <RevealOnScroll>
          <Lcp
            authResponse={authResponse}
            handleLinkedInLogin={handleLinkedInLogin}
            navigateLinkedInLogin={navigateLinkedInLogin}
            onStickyBarVisibilityChange={setIsStickyBarVisible}
          />
        </RevealOnScroll>
        
        <RevealOnScroll>
          <OurLearners />
        </RevealOnScroll>
    
       
          <div className="mt-[158px] flex w-full items-center justify-between gap-[92px]">
            <div className="flex-1">
              <StatsSection />
            </div>
            <div className="max-w-[554px]">
              <LoginForm
                authResponse={authResponse}
                isLinkedInLoading={isLinkedInLoading}
                navigateLinkedInLogin={navigateLinkedInLogin}
                formSwiperRef={formSwiperRefDesktop}
                formScrollRef={formScrollRef}
                dummyRef={dummyRefDesktop}
                handleFormSlide={handleFormSlide}
                loginEmailRef={loginEmailRefDesktop}
              />
            </div>
          </div>
         <RevealOnScroll animation="slide-up">
          <WhyLearnTube />
        </RevealOnScroll>
        <RevealOnScroll>
          <MoreThanSkills />
        </RevealOnScroll>
        <RevealOnScroll>
          <AwardsSectionDesktop />
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="mt-[64px] flex w-full flex-col items-center justify-center">
            <p className="whitespace-nowrap text-base font-normal leading-[normal] tracking-[0] text-[#ffffff80] [font-family:'Inter',Helvetica] md:text-[18px]">
              Success Stories Of Our
            </p>

            <h2
              className="mb-6 text-center text-2xl font-semibold leading-[normal] tracking-[0] text-white [font-family:'Inter',Helvetica] md:text-[32px] md:font-bold"
              style={{
                background:
                  "linear-gradient(to right, #FFFFFF 0%, #F7E394 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Amazing Learners
            </h2>
            <PlacementSuccessStory />
          </div>
        </RevealOnScroll>

        <RevealOnScroll>
          <ReadyToJoin authResponse={authResponse} />
        </RevealOnScroll>
      </div>
      <RevealOnScroll>
        <Footer25 />
      </RevealOnScroll>
      {
        loginModal && (
          <LoginModal isModalEnabled={loginModal} setIsModalEnabled={setLoginModal} />
        )
      }
      {showRecognisedSection && (
        <Suspense fallback={<LazySpinner />}>
          <OurLeanersModal showRecognisedSection={showRecognisedSection} />
        </Suspense>
      )}
    </div>
    {viewRef?.current && !isStickyBarVisible && <StickyBar authResponse={authResponse}/>}
    </div>
  );
};

export default LandingPage25;
